export default __webpack_public_path__ + "assets/webgl/glow.1d1e132f.png";